import * as React from 'react';
import {BuildingDetail} from './BuildingDetail';
import {Popup} from 'framework7-react';

export class BuildingDetailPopup extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isOpen: false
        };
    }

    onPopupClose() {
        this.setState({isOpen: false});
    }

    onPopupOpen() {
        this.setState({isOpen: true});
    }

    render() {
        return (
            <Popup className={this.props.slug}
                   tabletFullscreen="true"
                   onPopupOpen={this.onPopupOpen.bind(this)}
                   onPopupClose={this.onPopupClose.bind(this)}>
                <BuildingDetail building={this.props.building} isVisible={this.state.isOpen}/>
            </Popup>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/BuildingDetailPopup.jsx